import transition from "react-element-popper/animations/transition";
import opacity from "react-element-popper/animations/opacity";
import DateObject from "react-date-object";
import MultiDatePicker from "react-multi-date-picker";
import { useTranslation } from "react-i18next";
import persian from "react-date-object/calendars/persian";
import persianFa from "react-date-object/locales/persian_fa";
import { memo } from "react";

import type { IDatePickerProps } from "./types";

import type { ILocaleType } from "@configs";
import { InputV2 } from "@components/formControls/input";
import { useReadOnly } from "@/hooks";

export const DatePicker = memo(function DatePicker(props: IDatePickerProps) {
  const {
    onChange,
    readOnly: propsReadOnly,
    disabled,
    date,
    placeholder,
    canClear = true,
    onKeyDown,
    ...rest
  } = props;
  const readOnly = useReadOnly(propsReadOnly);
  const { i18n } = useTranslation();
  const lng = i18n.language as ILocaleType;
  let calender;
  let locale;

  if (lng === "fa") {
    calender = persian;
    locale = persianFa;
  }

  return (
    <MultiDatePicker
      portal
      render={
        <InputV2
          placeholder={
            placeholder ||
            new Date().toLocaleDateString(
              lng === "fa" ? "fa" : "zh-Hans-CN",
              props.onlyYear ? { year: "numeric" } : undefined,
            )
          }
          readOnly={readOnly}
          disabled={disabled}
          onKeyDown={(event) => {
            if (
              event.key === "Backspace" &&
              !readOnly &&
              !disabled &&
              canClear
            ) {
              onChange?.("");
            }
            onKeyDown?.(event);
          }}
          {...rest}
        />
      }
      animations={[opacity(), transition({ from: 35, duration: 800 })]}
      value={date}
      onChange={(val) => {
        if (val instanceof DateObject) {
          onChange?.(val.toDate().toISOString());
        }
      }}
      onlyYearPicker={props.onlyYear}
      calendar={calender}
      locale={locale}
      readOnly={readOnly}
      disabled={disabled}
    />
  );
});
